import React from 'react';
import { useAuth } from '@/context/AuthContext';

export default function DashboardPage() {
  const { user, logout } = useAuth();

  return (
    <main className="min-h-screen bg-gray-50 p-8" data-testid="dashboard-page">
      <div className="max-w-4xl mx-auto bg-white border border-gray-200 p-8">
        <h1 className="text-2xl font-black text-gray-900 mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Dashboard
        </h1>
        <p className="text-gray-600 mb-6">
          Signed in as <span className="font-semibold">{user?.username || user?.email || 'User'}</span>
        </p>

        <button
          type="button"
          onClick={logout}
          className="h-10 px-4 bg-[#A11212] hover:bg-[#8B0F0F] text-white text-sm font-semibold transition-colors"
        >
          Sign out
        </button>
      </div>
    </main>
  );
}
